module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-caption"
  }, [_c('h1', {
    staticClass: "anders"
  }, [_vm._v("mortgage notice")]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("借款办理流程")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "row-side col-xs-2"
  }, [_vm._v("办理流程")]), _vm._v(" "), _c('div', {
    staticClass: "paragraph-wrapper col-xs-10"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "item-title"
  }, [_vm._v("提交借款订单申请")]), _vm._v(" "), _c('p', [_vm._v("访问91weijia.com或关注官方微信号，在首页现在产品进入产品介绍页面，点击“立即申请”，进入贷款申请页面，填写贷款金额、贷款期限后，点击“提交订单”即可完成借款订单提交。")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "item-title"
  }, [_vm._v("完善个人信息")]), _vm._v(" "), _c('p', [_vm._v("点击“我的”，找到已提交的借款订单，点击“完善收款信息”进入个人信息补充页面。完成实名认证及收款卡信息的录入。点击“确认”提交即可。")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "item-title"
  }, [_vm._v("线下实地考察")]), _vm._v(" "), _c('p', [_vm._v("在完成个人信息录入后，伟嘉安捷贷款专员会第一时间联系您，确定相关贷款细节，并协助您办理相关资料及公证等。")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "item-title"
  }, [_vm._v("风控审核")]), _vm._v(" "), _c('p', [_vm._v("在贷款资料准备完成后，提交贷款资料，由伟嘉安捷风控团队进行风控审核。")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', {
    staticClass: "item-title"
  }, [_vm._v("放款")]), _vm._v(" "), _c('p', [_vm._v("在风控审核通过后，即可请求放款")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-31b7b97c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/process.vue
// module id = 591
// module chunks = 1